import { Layout, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { FundOutlined, LineChartOutlined, HistoryOutlined } from '@ant-design/icons';
import { IS_EMBEDDED } from '../config';
import { useTrading } from '../context/TradingContext';

const { Header, Sider, Content } = Layout;

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { totalValue, totalPnl, totalPnlPct } = useTrading();

  const menuItems = [
    { key: '/', label: <Link to="/">Portfolio</Link>, icon: <FundOutlined /> },
    { key: '/market', label: <Link to="/market">Market</Link>, icon: <LineChartOutlined /> },
    { key: '/history', label: <Link to="/history">History</Link>, icon: <HistoryOutlined /> },
  ];

  if (IS_EMBEDDED) {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Sider width={180} theme="light" style={{ borderRight: '1px solid #f0f0f0' }}>
          <div style={{ padding: '12px 16px', borderBottom: '1px solid #f0f0f0', fontSize: 13, fontWeight: 700 }}>
            Trading Sim
          </div>
          <Menu mode="inline" selectedKeys={[location.pathname]} items={menuItems} style={{ border: 'none' }} />
        </Sider>
        <Content style={{ background: '#fafafa' }}>{children}</Content>
      </Layout>
    );
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ display: 'flex', alignItems: 'center', gap: 32, background: '#001529', padding: '0 24px' }}>
        <span style={{ color: '#fff', fontWeight: 700, fontSize: 18 }}>Trading Simulator</span>
        <div style={{ marginLeft: 'auto', color: '#fff', fontSize: 13 }}>
          Portfolio: <strong style={{ color: '#52c41a' }}>${totalValue.toLocaleString('en', { minimumFractionDigits: 2 })}</strong>
          {' '}
          <span style={{ color: totalPnl >= 0 ? '#52c41a' : '#ff4d4f', marginLeft: 8 }}>
            {totalPnl >= 0 ? '+' : ''}{totalPnl.toFixed(2)} ({totalPnlPct.toFixed(2)}%)
          </span>
        </div>
      </Header>
      <Layout>
        <Sider width={180} theme="light" style={{ borderRight: '1px solid #f0f0f0' }}>
          <Menu mode="inline" selectedKeys={[location.pathname]} items={menuItems} style={{ border: 'none', paddingTop: 8 }} />
        </Sider>
        <Content style={{ background: '#fafafa' }}>{children}</Content>
      </Layout>
    </Layout>
  );
}
